import React from 'react';

const widthContentOnly = {
  width: '1px',
};

const ColGroup = () => (
  <colgroup>
    <col style={widthContentOnly} />
    <col style={{ width: '250px' }} />
    <col style={{ width: '250px' }} />
    <col style={widthContentOnly} />
  </colgroup>
);

export default ColGroup;
